import request from './request'


export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}
//菜单
export function getRouters(data) {
  return request({
    url: '/getRouters',
    method: 'GET',
    data: data
  })
}
//车型字典
export function listMcSeriesModels(data) {
  return request({
    url: '/dict/listMcSeriesModels',
    method: 'GET',
    data: data
  })
}
//车型字典
export function listMcSeriesModelsac(data) {
  return request({
    url: '/dict/listMcSeriesModels?filterByPartPrice=true',
    method: 'GET',
    data: data
  })
}
//车型字典
export function filterNoneCategory(data) {
  return request({
    url: '/dict/listMcSeriesModels?includePartCategoryUseTypes=3',
    method: 'GET',
    data: data
  })
}
//车型字典
export function filterNoneCategoryacc(data) {
  return request({
    url: '/dict/listMcSeriesModels?includePartCategoryUseTypes=3&filterByPartPrice=true',
    method: 'GET',
    data: data
  })
}
// 修改名称
export function userproname(data) {
  return request({
    url: '/system/user/profile',
    method: 'PUT',
    data: data
  })
}
// 修改密码
export function userupdatePwde(data) {
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'PUT',
    data: data,
    
    
  })
}


//员工角色列表
export function dealerUserauthRole(data) {
   let a = 'dealerUser'
  if(sessionStorage.getItem('platform')==2){
    a='retailerUser'
  }
  return request({
    url: '/system/'+a+'/authRole',
    method: 'GET',
    data: data
  })
}
//修改密码
export function dealerUserresetPwd(data) {
   let a = 'dealerUser'
  if(sessionStorage.getItem('platform')==2){
    a='retailerUser'
  }
  return request({
    url: '/system/'+a+'/resetPwd',
    method: 'PUT',
    data: data
  })
}
//修改库存下线
export function edstockOfDealer(data) {
 
  return request({
    url: '/aps/stockOfDealer',
    method: 'PUT',
    data: data
  })
}

//整车库存
export function stockOfDealerlist(data,dealerId, curPage, pageSize,mcSeriesModel,status,dealerType) {
  return request({
    url: '/aps/stockOfDealer/list?dealerId=' + dealerId + '&pageNum=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModel=' + mcSeriesModel + '&status=' + status+'&dealerType='+dealerType,
    method: 'GET',
    data: data
  })
 
}
//质保列表
export function woOfDealerlist(data, orderNumber, curPage, pageSize,applyingDealerId,status) {
   return request({
    url: '/aps/woOfDealer/list?orderNumber=' + orderNumber + '&pageNum=' + curPage + '&pageSize=' + pageSize + '&applyingDealerId=' + applyingDealerId + '&status=' + status+'&orderByColumn=create_time&isAsc=desc',
    method: 'GET',
    data: data
  })
}
//质保详情
export function woOfDealercont(data, id) {

   return request({
    url: '/aps/woOfDealer/'+id,
    method: 'GET',
    data: data
  })
}
export function putDealercont(data) {

   return request({
    url: '/aps/woOfDealer',
    method: 'PUT',
    data: data
  })
}
//审核采购单
export function poAuditOfDealer(data,approval,poId) {
  return request({
    url: '/po/poAuditOfDealer?approval=' + approval + '&poId=' + poId,
    method: 'GET',
    data: data
  })
}

//我的账户
export function myAcc(data) {
  return request({
    url: 'acc/myAcc',
    method: 'GET',
    data: data
  })
}
//我的账户列表 零售
export function myAccLis(data,searchKey) {
  return request({
    url: 'acc/myAccList?searchKey='+searchKey,
    method: 'GET',
    data: data
  })
}
//我的账户流水
export function accmyAccLog(data, accTypeId, curPage, pageSize,orderNumber,transactionTypeId,startDateTime,endDateTime) {
  return request({
    url: '/acc/myAccLog?accId=' + accTypeId + '&curPage=' + curPage + '&pageSize=' + pageSize + '&orderNumber=' + orderNumber + '&transactionTypeId=' + transactionTypeId+ '&startDateTime=' + startDateTime+ '&endDateTime=' + endDateTime,
    method: 'GET',
    data: data
  })
}
//个人资料
export function systemuser(data) {
  return request({
    url: '/system/user/profile',
    method: 'GET',
    data: data
  })
}
//个人资料
export function getInfo(data) {
  return request({
    url: '/getInfo',
    method: 'GET',
    data: data
  })
}

//取消发货

export function quxfa(data, poId,remarks) {

  return request({
    url: '/po/myPoShipmentCancel?poId=' + poId+'&remarks='+remarks ,
    method: 'GET',
    data: data
  })
}
//零售商列表

export function retailerlist(data, curPage, pageSize) {

  return request({
    url: '/system/retailer/list?pageNum=' + curPage + '&pageSize=' + pageSize,
    method: 'GET',
    data: data
  })
}
//零售商列表

export function retailerlisa(data, curPage, pageSize,dealerNameFull) {

  return request({
    url: '/system/retailer/list?pageNum=' + curPage + '&pageSize=' + pageSize+'&searchValue='+dealerNameFull,
    method: 'GET',
    data: data
  })
}
//员工列表
export function dealerUserlist(data, curPage, pageSize) {
  let a = 'dealerUser'
  if(sessionStorage.getItem('platform')==2){
    a='retailerUser'
  }
  return request({
    url: '/system/'+a+'/list?curPage=' + curPage + '&pageSize=' + pageSize,
    method: 'GET',
    data: data
  })
}
//添加员工账号
export function updatadealerUser(data) {
   let a = 'dealerUser'
  if(sessionStorage.getItem('platform')==2){
    a='retailerUser'
  }
  return request({
    url: '/system/'+a,
    method: 'post',
    data: data
  })
}



//添加经销商
export function updataretailer(data) {

  return request({
    url: '/system/retailer',
    method: 'post',
    data: data
  })
}
//erp制单
export function submitMyErpOrder(data) {

  return request({
    url: '/po/submitMyErpOrder',
    method: 'post',
    data: data
  })
}
//打印标签
export function partLabelOfDealer(data) {

  return request({
    url: '/partLabelOfDealer/print',
    method: 'post',
    data: data
  })
}
//零售商页面编辑
export function putdealerUsera(data) {
 
  return request({
    url: '/system/retailer',
    method: 'put',
    data: data
  })
}
//零售商erplist
export function dealerAreaOfRetailerlist(data,dealerId) {
 
  return request({
    url: '/system/dealerAreaOfRetailer/list?dealerId='+dealerId,
    method: 'get',
    data: data
  })
}
//零售商erplist
export function dealerAreaOfReta(data) {
 
  return request({
    url: '/system/dealerAreaOfRetailer',
    method: 'put',
    data: data
  })
}
//零售商erplist
export function delerAreaOfReta(data,ids) {
 
  return request({
    url: '/system/dealerAreaOfRetailer/'+ids,
    method: 'delete',
    data: data
  })
}
export function deleretailer(data,ids) {
 
  return request({
    url: '/system/retailer/'+ids,
    method: 'delete',
    data: data
  })
}
//员工编辑
export function putdealerUser(data) {
   let a = 'dealerUser'
  if(sessionStorage.getItem('platform')==2){
    a='retailerUser'
  }
  return request({
    url: '/system/'+a,
    method: 'put',
    data: data
  })
}
//订单
export function pomyPos(data, curPage, pageSize, statusList,paymentMethod,orderNumber,orderType) {
  return request({
    url: '/po/myPos?curPage=' + curPage + '&pageSize=' + pageSize + '&statusList=' + statusList + '&paymentMethod=' + paymentMethod + '&searchKey=' + orderNumber+'&orderType='+orderType,
    method: 'GET',
    data: data
  })
}
//零售商订单
export function pomyPosa(data, curPage, pageSize, statusList,paymentMethod,orderNumber,orderType,orderName) {
  return request({
    url: '/po/myPos?curPage=' + curPage + '&pageSize=' + pageSize + '&statusList=' + statusList + '&paymentMethod=' + paymentMethod + '&searchKey=' + orderNumber+'&orderType='+orderType+'&orderName='+orderName,
    method: 'GET',
    data: data
  })
}
//员工辑
export function orderSearch(data, orderNumber) {
  return request({
    url: '/po/getPoDto?poId=' + orderNumber,
    method: 'GET',
    data: data
  })
}

//配件分类查询
export function pageQueryPartCategory(data, curPage, pageSize, mcSeriesModelId, searchKey) {
  return request({
    url: '/part/pageQueryPartCategory?curPage=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&searchKey=' + searchKey,
    method: 'GET',
    data: data
  })
}
//配件新增
export function postOfDealer(data) {
  return request({
    url: '/aps/partRetailerOfDealer',
    method: 'post',
    data: data
  })
}
//配件修改
export function putOfDealer(data) {
  return request({
    url: '/aps/partRetailerOfDealer',
    method: 'PUT',
    data: data
  })
}
//配件删除
export function deleOfDealer(data,ids) {
  return request({
    url: '/aps/partRetailerOfDealer/'+ids,
    method: 'DELETE',
    data: data
  })
}
//配件查询
export function partRetailerOfDealer(data, curPage, pageSize, mcSeriesModelId, searchKey, categoryId,status) {
  return request({
    url: '/aps/partRetailerOfDealer/list?pageNum=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&searchValue=' + searchKey + '&categoryId=' + categoryId+'&status='+status,
    method: 'GET',
    data: data
  })
}
//配件查询
export function partRetailerOfDealerac(data, curPage, pageSize, mcSeriesModelId, searchKey) {
 return request({
    url: '/part/pageQueryPart?curPage=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&searchKey=' + searchKey+'&status=1',
    method: 'GET',
    data: data
  })
  }
  //配件查询
export function pageQueryPoPart(data, curPage, pageSize, dealerId, searchKey) {
 return request({
    url: '/poPartOfDealer/pageQueryPoPart?curPage=' + curPage + '&pageSize=' + pageSize + '&dealerId=' + dealerId + '&searchKey=' + searchKey+'&statusList%5B0%5D=2&statusList%5B1%5D=3&shippedQuantity=999&orderType=1',
    method: 'GET',
    data: data
  })
  }
    //配件查询
export function pageQueryPoPartaca(data, curPage, pageSize, dealerId, searchKey) {
 return request({
    url: '/poPartOfDealer/pageQueryPoPart?curPage=' + curPage + '&pageSize=' + pageSize + '&dealerId=' + dealerId + '&searchKey=' + searchKey,
    method: 'GET',
    data: data
  })
  }
   //发货单
export function shipdele(data, id) {
 return request({
    url: '/aps/shipmentOfDealer/' + id ,
    method: 'GET',
    data: data
  })
}     
   //发货单整车模板
export function pageQueryPoPartByImportVin(data) {
 return request({
    url: '/poPartOfDealer/pageQueryPoPartByImportVin/template' ,
    method: 'POST',
    data: data,
      responseType: "blob"
  })
}    

  //发货单
export function shipmentOfDealer(data, curPage, pageSize, logisticsNumber) {
 return request({
    url: '/aps/shipmentOfDealer/myList?pageNum=' + curPage + '&pageSize=' + pageSize + '&logisticsNumber=' + logisticsNumber+'&isAsc=desc&orderByColumn=shipped_time',
    method: 'GET',
    data: data
  })
}     
  //下级发货单
export function xjshipmentOfDealer(data, curPage, pageSize, logisticsNumber) {
 return request({
    url: '/aps/shipmentOfDealer/nextList?pageNum=' + curPage + '&pageSize=' + pageSize + '&logisticsNumber=' + logisticsNumber+'&isAsc=desc&orderByColumn=shipped_time',
    method: 'GET',
    data: data
  })
}   
  //发货单
export function subshipmentOfDealer(data) {
 return request({
    url: '/aps/shipmentOfDealer' ,
    method: 'post',
    data: data
  })
}

//配件查询
export function pageQueryPart(data, curPage, pageSize, mcSeriesModelId, searchKey, categoryId) {
  return request({
    url: '/part/pageQueryPart?curPage=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&searchKey=' + searchKey + '&categoryId=' + categoryId+'&status=1',
    method: 'GET',
    data: data
  })
}
//配件查询搜索按钮
export function pageQueryParta(data, curPage, pageSize, mcSeriesModelId, searchKey) {
  return request({
    url: '/part/pageQueryPart?curPage=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&searchKey=' + searchKey+'&status=1',
    method: 'GET',
    data: data
  })
}
//配件查询搜索按钮
export function pageQueryParta1(data, curPage, pageSize, mcSeriesModelId, chassisNumberPrefix) {
  return request({
    url: '/part/pageQueryPartCategory?curPage=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&chassisNumberPrefix=' + chassisNumberPrefix,
    method: 'GET',
    data: data
  })
}
//加入购物车
export function addCart(data, partId, quantity,orderType) {
  console.log(data)
  return request({
    url: '/cart/add?partId=' + partId + '&quantity=' + quantity+'&orderType='+orderType,
    method: 'GET',
    data: data
  })
}
//发货单列表
export function ShipmentDetailsrlist(data, poShipmentId,curPage ,pageSize,poId) {
  return request({
    url: '/po/getPoShipmentDetails?poShipmentId=' + poShipmentId + '&curPage=' + curPage+ '&pageSize=' + pageSize+ '&poId=' + poId,
    method: 'GET',
    data: data
  })
}
//销售尾单列表
export function PartOfDealerlist(data, orderNumber, orderType,retailerId,curPage,pageSize,orderName,pageNum,queryShipmentStatus) {
  return request({
    url: '/aps/unshippedPartOfDealer/list?searchValue=' + orderNumber + '&orderType=' + orderType+ '&retailerId=' + retailerId+ '&curPage=' + curPage+ '&pageSize=' + pageSize+'&orderName='+orderName+ '&pageNum=' + pageNum+ '&queryShipmentStatus=' + queryShipmentStatus,
    method: 'GET',
    data: data
  })
}
export function unshippedPartOfDealera(data,orderNumber, orderType,retailerId,curPage,pageSize,orderName,pageNum,queryShipmentStatus) {
   return request({
    url: '/aps/unshippedPartOfDealer/nextList?searchValue=' + orderNumber + '&orderType=' + orderType+ '&dealerId=' + retailerId+ '&curPage=' + curPage+ '&pageSize=' + pageSize+'&orderName='+orderName+ '&pageNum=' + pageNum+ '&queryShipmentStatus=' + queryShipmentStatus,
    method: 'GET',
    data: data
  })
}

//采购单取消
export function cancelOrder(data, poId, remarks) {
  console.log(data)
  return request({
    url: '/po/myPoCancel?poId=' + poId + '&remarks=' + remarks,
    method: 'GET',
    data: data
  })
}
//LINGSHOU采购单数量
export function pageSumMyPoA(data) {
  console.log(data)
  return request({
    url: '/po/pageSumMyPo?orderName=SO' ,
    method: 'GET',
    data: data
  })
}
//结算
export function poAddSettleAmount(data) {
 
  return request({
    url: '/po/poAddSettleAmount' ,
    method: 'POST',
    data: data
  })
}

//LINGSHOU采购发货单
export function getPoShipments(data, curPage, pageSize,logisticsNumber) {

  return request({
    url: '/po/getPoShipments?curPage='+curPage+'&pageSize='+pageSize+'&logisticsNumber='+logisticsNumber,
    method: 'GET',
    data: data
  })
}
//几张
export function jzbook(data, accId, amount,transactionTypeId,comment) {

  return request({
    url: '/acc/book?accId='+accId+'&amount='+amount+'&transactionTypeId='+transactionTypeId+'&comment='+comment,
    method: 'GET',
    data: data
  })
}
//设置折扣扣
export function shezhilzekk(data, accId, newDiscountRate) {

  return request({
    url: '/acc/updateDiscountRate?accId='+accId+'&newDiscountRate='+newDiscountRate,
    method: 'GET',
    data: data
  })
}
//采购单数量
export function pageSumMyPo(data) {
  console.log(data)
  return request({
    url: '/po/pageSumMyPo' ,
    method: 'GET',
    data: data
  })
}
//赔付清单
export function cartCoOfDealerlist(data,parmes) {
  console.log(data)
  return request({
    url: '/aps/cartCoOfDealer/myList'+parmes ,
    method: 'GET',
    data: data
  })
}
//赔付清单
export function cartCoOfDealerlista(data,parmes) {
  console.log(data)
  return request({
    url: '/aps/cartCoOfDealer/nextList'+parmes ,
    method: 'GET',
    data: data
  })
}


//审核
export function coAuditByDealer(data,parmes) {
  console.log(data)
  return request({
    url: '/co/coAuditByDealer'+parmes ,
    method: 'GET',
    data: data
  })
}
//同意
export function coConfirm(data,parmes) {
  console.log(data)
  return request({
    url: '/co/coConfirm'+parmes ,
    method: 'GET',
    data: data
  })
}
//车型价格表
export function partPriceOfRetailer(data, curPage, pageSize, mcSeriesModelId, searchKey, status) {
  return request({
    url: '/aps/partPriceOfRetailer/list?pageNum=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&dealerName=' + searchKey + '&status=' + status+'&isAsc=desc&orderByColumn=updateTime',
    method: 'GET',
    data: data
  })
}
//车型新增价格
export function postOfRetailer(data) {
  return request({
    url: '/aps/partPriceOfRetailer',
    method: 'post',
    data: data
  })
}
export function deleOfRetailer(data,ids) {
  return request({
    url: '/aps/partPriceOfRetailer/'+ids,
    method: 'delete',
    data: data
  })
}

export function putOfRetailer(data) {
  return request({
    url: '/aps/partPriceOfRetailer',
    method: 'put',
    data: data
  })
}
//我的理赔列表
export function pageQueryMyCo(data, curPage, pageSize, mcSeriesModelId, searchKey, status, saTypeId, startTime, endTime,dealerAreaId) {
  return request({
    url: '/co/pageQueryMyCo?curPage=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&searchKey=' + searchKey + '&status=' + status + '&claimType=' + saTypeId + '&startApplicationTime=' + startTime + '&endApplicationTime=' + endTime+'&dealerAreaId='+dealerAreaId,
    method: 'GET',
    data: data
  })
}
//我的理赔列表a
export function pageQueryMyCoa(data, curPage, pageSize, mcSeriesModelId, searchKey, status, saTypeId, startTime, endTime,dealerAreaId) {
  return request({
    url: '/co/pageQueryMyCo?curPage=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&searchKey=' + searchKey + '&status=' + status + '&claimType=' + saTypeId + '&startApplicationTime=' + startTime + '&endApplicationTime=' + endTime+'&dealerAreaId='+dealerAreaId+'&onlyQueryRetailer=true',
    method: 'GET',
    data: data
  })
}
//销售车型管理
export function pageQueryMyCoaa(data, curPage, pageSize, mcSeriesModelId, searchKey, status, saTypeId, startTime, endTime,dealerAreaId) {
  return request({
    url: '/co/pageQueryMyCo?curPage=' + curPage + '&pageSize=' + pageSize + '&mcSeriesModelId=' + mcSeriesModelId + '&searchKey=' + searchKey + '&status=' + status + '&claimType=' + saTypeId + '&startApplicationTime=' + startTime + '&endApplicationTime=' + endTime+'&dealerAreaId='+dealerAreaId,
    method: 'GET',
    data: data
  })
}
//字典
export function querytype(data, dictType) {
  return request({
    url: '/system/dict/data/query/type/' + dictType + '/',
    method: 'GET',
    data: data
  })
}
//国别 字典
export function gbquerytype(data, dictType,relateValue) {
  return request({
    url: '/system/dict/data/query/type/' + dictType + '/'+relateValue +'/'    ,
    method: 'GET',
    data: data
  })
}

//购物车列表
export function cartList(data) {
  return request({
    url: '/cart/list',
    method: 'GET',
    data: data
  })
}
//购物车列表 客诉
export function cartLista(data) {
  return request({
    url: '/aps/cartCo/list',
    method: 'GET',
    data: data
  })
}
//购物车列表 客诉
export function cartListaa(data,dearerAreaId,searchValue) {
  return request({
    url: '/aps/cartCo/list?dearerAreaId='+dearerAreaId+'&searchValue='+searchValue,
    method: 'GET',
    data: data
  })
}
//购物车删除
export function cartDel(data, cardId) {
  return request({
    url: '/cart/delete?cardId=' + cardId,
    method: 'GET',
    data: data
  })
}

//购物车数量修改
export function cartQuantity(data, cardId, num) {
  return request({
    url: '/cart/quantity?cardId=' + cardId + '&quantity=' + num,
    method: 'GET',
    data: data
  })
}
//购物车下单
export function cartorder(data, accTypeId, address, cardId, paymentMethod, priceTerms, shippingMethod, userRemarks,shippingDate,planNum,currencyType) {
  return request({
    url: '/cart/order?accTypeId=' + accTypeId + '&address=' + address + '&cardId=' + cardId + '&paymentMethod=' + paymentMethod + '&priceTerms=' + priceTerms + '&shippingMethod=' + shippingMethod + '&userRemarks=' + userRemarks+ '&shippingDate=' + shippingDate+ '&planNum=' + planNum + '&currencyType=' + currencyType,
    method: 'GET',
    data: data
  })
}
//购物车下单
export function cartordera(data) {
  return request({
    url: '/cart/order' ,
    method: 'GET',
    data: data
  })
}
//文档列表
export function documentList(data,mcSeriesModel, category, type, startTime, endTime, status, searchValue,pageNum,pageSize) {
  return request({
    url: '/system/myDocument/list?mcSeriesModel=' + mcSeriesModel + '&category=' + category + '&type=' + type + '&startTime=' + startTime + '&endTime=' + endTime + '&status=' + status + '&searchValue=' + searchValue+ '&pageNum=' + pageNum+ '&pageSize=' + pageSize,
    method: 'GET',
    data: data
  })
}
//文档列表上传列表
export function documentLista(data,mcSeriesModel, category, type, startTime, endTime, status, searchValue,pageNum,pageSize,platform) {
  return request({
    url: '/system/dealerDocument/list?mcSeriesModel=' + mcSeriesModel + '&category=' + category + '&type=' + type + '&startTime=' + startTime + '&endTime=' + endTime + '&status=' + status + '&searchValue=' + searchValue+ '&pageNum=' + pageNum+ '&pageSize=' + pageSize+'&platform='+platform+'&isAsc=desc&orderByColumn=createTime',
    method: 'GET',
    data: data
  })
}
//发票列表
export function InvoiceOfDealer(data,title, type, retailerId, pageNum,pageSize) {
  return request({
    url: '/aps/InvoiceOfDealer/list?title=' + title + '&type=' + type + '&retailerId=' + retailerId +  '&pageNum=' + pageNum+ '&pageSize=' + pageSize,
    method: 'GET',
    data: data
  })
}

//文档列表上传列表新增
export function updataDocument(data) {
  return request({
    url: '/system/dealerDocument',
    method: 'post',
    data: data
  })
}
//文档列表上传列表新增
export function putDocument(data) {
  return request({
    url: '/system/dealerDocument',
    method: 'PUT',
    data: data
  })
}
//删除员工 
export function deleDocument(data,ids) {
  return request({
    url: '/system/dealerDocument/' + ids,
    method: 'DELETE',
    data: data
  })
}
//删除员工 
export function deleInvoiceOfDealer(data,ids) {
  return request({
    url: 'aps/InvoiceOfDealer/' + ids,
    method: 'DELETE',
    data: data
  })
}
//删除公告通知
export function deleNoticet(data,ids) {
  return request({
    url: '/system/dealerNotice/' + ids,
    method: 'DELETE',
    data: data
  })
}

//通知列表
export function noticetList(data, status,noticeTitle,noticeType,curPage, pageSize,isAsc,orderByColumn) {
  return request({
    url: '/system/myNotice/list?status=' + status + '&noticeTitle=' + noticeTitle+ '&noticeType=' + noticeType+ '&curPage=' + curPage+ '&pageSize=' + pageSize+'&isAsc='+isAsc+'&orderByColumn='+orderByColumn,
    method: 'GET',
    data: data
  })
}
//通知列表发布页
export function noticetLista(data, noticeTitle,noticeType,curPage, pageSize) {
  return request({
    url: '/system/dealerNotice/list?noticeTitle=' + noticeTitle + '&noticeType=' + noticeType+ '&curPage=' + curPage+ '&pageSize=' + pageSize,
    method: 'GET',
    data: data
  })
}
//车辆详情理赔信息
export function vincont(data, vin,curPage,pageSize) {
  return request({
    url: '/co/pageQueryMyCo?vin=' + vin + '&curPage=' + curPage+ '&pageSize=' + pageSize,
    method: 'GET',
    data: data
  })
}
//通知列表发布页 发布
export function noticetup(data) {
  return request({
    url: '/system/notice',
    method: 'POST',
    data: data
  })
}
//通知列表发布页 修改
export function noticetedr(data) {
  return request({
    url: '/system/notice',
    method: 'PUT',
    data: data
  })
}
//经销商通知详情 
export function noticetDetails(data, id) {
  return request({
    url: '/system/noticeOfDealer/' + id,
    method: 'GET',
    data: data
  })
}
//经销商通知已读 
export function setNoticet(data, id) {
  return request({
    url: '/system/myNotice',
    method: 'PUT',
    data: data
  })
}

//账户类型列表 
export function listAccType(data, permissions) {
  return request({
    url: '/dict/listAccType?permissions=' + permissions,
    method: 'GET',
    data: data
  })
}

//交易类型列表
export function listAccTransactionType(data) {
  return request({
    url: '/dict/listAccTransactionType',
    method: 'GET',
    data: data
  })
}

//删除员工 
export function deleteUser(data,userIds) {
   let a = 'dealerUser'
  if(sessionStorage.getItem('platform')==2){
    a='retailerUser'
  }
  return request({
    url: '/system/'+a+'/' + userIds,
    method: 'DELETE',
    data: data
  })
}


//更新订单
export function myPoUpdate(data) {
  return request({
    url: '/po/myPoUpdate',
    method: 'POST',
    data: data
  })
}

//导出账户
export function exportMyTransactionLog(data,accId) {
  return request({
    url: '/acc/exportMyTransactionLog?accId='+accId,
    method: 'get',
    data: data,
     responseType: "blob"
  })
}






//取消我的理赔
export function cancelMyCo(params) {
  return request({
    url: '/co/cancelMyCo?'+params,
    method: 'GET',
  })
}
//我的理赔单详情
export function getMyCoDto(params) {
  return request({
    url: '/co/getMyCoDto?'+params,
    method: 'GET',
  })
}
//我的质保单详情
export function apsgetMyCoDto(params) {
  return request({
    url: '/aps/moOfDealer/'+params,
    method: 'GET',
  })
}
//整车发货单发明细导入
export function pmportVin(params,urlPath) {
  return request({
    url: '/poPartOfDealer/pageQueryPoPartByImportVin?urlPath='+urlPath,
    method: 'GET',
  })
}

//新增质保单
export function upwoOfDealer(data) {
  return request({
    url: '/aps/woOfDealer',
    method: 'POST',
    data: data
  })
}

//我的理赔单列表查询(数据统计)
export function pageMySumCo(params) {
  return request({
    url: '/co/pageMySumCo?'+params,
    method: 'GET',
  })
}
//导出订单
export function exportMyCo(params) {
  return request({
    url: '/co/exportMyCo?'+params,
    method: 'GET',
    responseType: "blob"
  })
}


//导出订单
export function exportMyCoDetails(params) {
  return request({
    url: '/co/exportMyCoDetails?'+params,
    method: 'GET',
    responseType: "blob"
  })
}
//活动工时查询
export function pageQuerySaLabour(params) {
  return request({
    url: '/co/pageQuerySaLabour?'+params,
    method: 'GET',
  })
}
//活动配件查询
export function pageQuerySaPart(param) {
  return request({
    url: '/co/pageQuerySaPart' + param,
    method: 'GET',
  })
}
//车架号查询
export function pageQueryVin(params) {
  return request({
    url: '/co/pageQueryVin?'+params,
    method: 'GET',
  })
}
//是否可以提交理赔单据
export function submitCan(params) {
  return request({
    url: '/co/submitCan?'+params,
    method: 'GET',
  })
}
//提交理赔单据
export function submitCoDto(data) {
  return request({
    url: '/co/submitCoDto',
    method: 'POST',
    data: data
  })
}
//提交理赔单据
export function submitCoDtoaa(data) {
  return request({
    url: '/co/updateCo',
    method: 'POST',
    data: data
  })
}
//提交理赔单据
export function submisaveCoDto(data) {
  return request({
    url: '/co/saveCoDto',
    method: 'POST',
    data: data
  })
}
//提交维保订单
export function submoOfDealer(data) {
  return request({
    url: '/aps/moOfDealer',
    method: 'POST',
    data: data
  })
}
//编辑维保订单
export function putmoOfDealer(data) {
  return request({
    url: '/aps/moOfDealer',
    method: 'PUT',
    data: data
  })
}
//修改理赔单据
export function updateMyCo(data) {
  return request({
    url: '/co/updateMyCo',
    method: 'POST',
    data: data
  })
}

//上传文件
export function upload(data) {
  return request({
    url: '/file/upload',
    method: 'POST',
    headers:{
      'Content-Type':'multipart/form-data'
    },
    data: data
  })
}
//上传文件
export function InvoiceOfDealeradd(data) {
  return request({
    url: '/aps/InvoiceOfDealer/add',
    method: 'POST',
    headers:{
      'Content-Type':'multipart/form-data'
    },
    data: data
  })
}
//上传文件
export function uploadaacx(data) {
  return request({
    url: '/common/upload',
    method: 'POST',
    headers:{
      'Content-Type':'multipart/form-data'
    },
    data: data
  })
}
//维保列表
export function moOfDealerlist(params) {
  return request({
    url: '/aps/moOfDealer/list?'+params,
    method: 'GET',
  })
}
//查询车辆列表
export function mcVehicleOfDealerList(params) {
  return request({
    url: '/aps/mcVehicleOfDealer/list?'+params,
    method: 'GET',
  })
}
//查询车辆列表
export function mcVehicleOfDealerLista(params) {
  return request({
    url: '/aps/mcVehicleOfDealer/listBySearchValue?'+params,
    method: 'GET',
  })
}
//获取车辆详细信息
export function mcVehicleOfDealerInfo(params) {
  return request({
    url: '/aps/mcVehicleOfDealer/'+params,
    method: 'GET',
  })
}
//向工厂理赔
export function submitCo2Platform(params) {
  return request({
    url: '/co/submitCo2Platform/'+params,
    method: 'POST',
  })
}

//配件列表查询
export function pageQueryPartList(params) {
  return request({
    url: '/part/pageQueryPart?'+params,
    method: 'GET',
  })
}

//工时详情列表查询
export function pageQueryLabourDetailDtos(params) {
  return request({
    url: '/sa/pageQueryLabourDetailDtos?'+params,
    method: 'GET',
  })
}
//活动列表查询
export function pageQuerySa(params) {
  return request({
    url: '/sa/pageQuerySa?'+params,
    method: 'GET',
  })
}

//新增车辆
export function aaddmcVehicleOfDealer(data) {
  return request({
    url: 'aps/mcVehicleOfDealer/',
    method: 'POST',
    data: data
  })
}

//修改车辆
export function changemcVehicleOfDealer(data) {
  return request({
    url: 'aps/mcVehicleOfDealer/',
    method: 'PUT',
    data: data
  })
}

//上传文件
export function importFile(data) {
  return request({
    url: '/cart/import',
    method: 'POST',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  })
}
//上传文件
export function importFilea(data) {
  return request({
    url: '/co/importVinInfo',
    method: 'POST',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  })
}
//我的采购订单导出
export function exportMyPo(params) {
  return request({
    url: 'po/exportMyPo',
    method: 'GET',
       responseType: "blob"
  })
}

//我的采购订单导出明细
export function exportMyPoDetails(params) {
  return request({
    url: 'po/exportMyPoDetails',
    method: 'GET',
       responseType: "blob"
  })
}
//我的采购订单导出明细
export function exportMyPoDetailsa(params,status) {
  return request({
    url: 'po/exportMyPoDetails?ids='+status,
    method: 'GET',
       responseType: "blob"
  })
}
//订单重新提交
export function myPoReApply(data) {
  return request({
    url: 'po/myPoReApply',
    method: 'GET',
    data:data
  })
}
//我的采购订单发货明细导出
export function exportDetails(poShipmentId) {
  return request({
    url: 'po/myPoReApply?poShipmentId=' + poShipmentId,
    method: 'GET',
  })
}


//批量注册车辆模板下载
export function templateDowload(data) {
  return request({
    url: 'aps/mcVehicleOfDealer/import/template',
    method: 'POST',
    data: data
  })
}

//上传文件
export function importFiles(data) {
  return request({
    url: 'aps/mcVehicleOfDealer/import',
    method: 'POST',
    responseType: "blob",
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
  
  })
}